interface ToggleProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <label className={`inline-flex items-center gap-2 ${disabled ? "opacity-50" : "cursor-pointer"}`}>
      <span
        className={`relative inline-block w-10 h-[22px] rounded-full transition-colors ${
          checked ? "bg-text-warning" : "bg-border-strong"
        }`}
      >
        <span
          className={`absolute top-[2px] w-[18px] h-[18px] bg-white rounded-full shadow transition-all ${
            checked ? "left-[20px]" : "left-[2px]"
          }`}
        />
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          className="sr-only"
          disabled={disabled}
        />
      </span>
      {label && <span className="text-xs">{label}</span>}
    </label>
  );
}
